import { CommonService } from "../common.service";
import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from '@angular/router';
var AbilityReportComponent = (function () {
    function AbilityReportComponent(router, apiService, route, commonService) {
        this.router = router;
        this.apiService = apiService;
        this.route = route;
        this.commonService = commonService;
        this.showInfo = true;
        this.isOpenClass = 0;
        this.isSlide = true;
        this.isClicked = true;
    }
    AbilityReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
        // this.mockData();
        setTimeout(function () {
            _this.isSlide = false;
        }, 4000);
        this.getApiData();
    };
    AbilityReportComponent.prototype.elementScroll = function ($event) {
        var nav = document.getElementById("surveyNav"), secOffset = document.getElementById("secondSection").offsetTop - 100, thdOffset = document.getElementById("thirdSection").offsetTop - 150;
        var clientHeight = $event.target.clientHeight, scrollTop = $event.target.scrollTop, scrollHeight = $event.target.scrollHeight;
        // console.log($event.target.clientHeight);
        // console.log($event.target.scrollTop);
        // console.log($event.target.scrollHeight);
        if ($event.target.scrollTop >= 150) {
            nav.style.display = "block";
            if ($event.target.scrollTop >= secOffset && $event.target.scrollTop < thdOffset) {
                $('#surveyNav ul li').eq(1).addClass('active').siblings().removeClass('active');
            }
            if ($event.target.scrollTop >= thdOffset || clientHeight + scrollTop >= scrollHeight - 1) {
                $('#surveyNav ul li').eq(2).addClass('active').siblings().removeClass('active');
            }
            // if($event.target.scrollTop >=thdOffset ||  $event.target.scrollTop  >= $event.target.offsetHeight*0.9){
            //   $('#surveyNav ul li').eq(2).addClass('active').siblings().removeClass('active');
            // }
        }
        else {
            nav.style.display = "none";
            $('#surveyNav ul li').eq(0).addClass('active').siblings().removeClass('active');
        }
    };
    AbilityReportComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        $('body').addClass('heightAuto');
        this.commonService.initPage();
        var that = this;
        setTimeout(function () {
            _this.hammertime = new Hammer(document.getElementById('swipeContainer'));
            _this.hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
            _this.hammertime.on('swipeup swipedown', function (ev) {
                that.logEventType(ev, that);
            });
        }, 500);
        setTimeout(function () {
            var charts = echarts.init(document.getElementById('circleCharts'));
            charts.setOption(_this.chartsOpt);
        }, 1500);
    };
    AbilityReportComponent.prototype.logEventType = function (ev, that) {
        if (ev.type == "swipeup") {
            $('#swipeContainer').css({
                'top': '-100%',
                'opacity': '0'
            });
            that.hammertime.get('swipe').set({ enable: false });
            setTimeout(function () {
                $(".abilityReport").css({ 'opacity': '1' });
                $('#swipeContainer').hide();
            }, 300);
        }
    };
    //   isBottom(target){
    //     let clientHeight = target.scrollTop === 0 ? document.body.clientHeight : document.documentElement.clientHeight;
    //     let scrollTop = target.scrollTop === 0 ? document.body.scrollTop : document.documentElement.scrollTop;
    //     let scrollHeight = target.scrollTop === 0 ? document.body.scrollHeight : document.documentElement.scrollHeight;
    //
    //     console.log(clientHeight+';'+scrollTop+';'+scrollHeight);
    //     if (clientHeight + scrollTop === scrollHeight) {
    //       return true;
    //     }else{
    //       return false;
    //     }
    // }
    AbilityReportComponent.prototype.mockData = function () {
        var href = window.location.href.split('/');
        this.surveyStatus = Number(href[href.length - 1]);
        this.learningMetaId = Number(href[href.length - 2]);
        if (this.surveyStatus == 1) {
            this.pageTitle = "能力诊断报告";
            this.apiServiceUrl = '/survey/beforeTestRepote/';
        }
        else if (this.surveyStatus == 2) {
            this.pageTitle = "能力考核报告";
            this.apiServiceUrl = '/survey/afterTestReport/';
        }
        this.level = 2;
        this.levelDesc = '123123';
        this.faceUrl = "../../assets/picture/reportnew/L" + this.level + ".png";
        this.beforeLevel = 4;
        this.afterLevel = 2;
        this.beforeLevelName = 'aa';
        this.afterLevelName = 'bb';
        this.beforeLevelDesc = 'aaa';
        this.afterLevelDesc = 'bbb';
        var beforeAdvantages = ['aaa', 'bbb'];
        var afterAdvantages = ['aaa', 'bbb'];
        this.beforeLevelAdvantages = '<b>优势行为</b><br/><br/>';
        for (var i = 0, len = beforeAdvantages.length; i < len; i += 1) {
            this.beforeLevelAdvantages += beforeAdvantages[i] + '<br />';
        }
        this.afterLevelAdvantages = '<b>优势行为</b><br/><br/>';
        for (var i = 0, len = afterAdvantages.length; i < len; i += 1) {
            this.afterLevelAdvantages += afterAdvantages[i] + '<br />';
        }
        var beforeShort = ['在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。', '在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。'];
        var afterShort = ['在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。', '在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。'];
        this.beforeLevelShort = '<b>短板行为</b><br/><br/>';
        for (var i = 0, len = beforeShort.length; i < len; i += 1) {
            this.beforeLevelShort += beforeShort[i] + '<br />';
        }
        this.afterLevelShort = '<b>短板行为</b><br/><br/>';
        for (var i = 0, len = afterShort.length; i < len; i += 1) {
            this.afterLevelShort += afterShort[i] + '<br />';
        }
        this.courseName = '协作';
        this.surveyTutor = 'aldklasjdlkasjldajskldjlasdjldklasdklasjldjkasdklas';
        this.advantages = ['在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。', '在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。'];
        this.short = ['在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。', '在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。'];
        // this.learningTips = [{'title':'1110','content':'435345'},{'title':'1110','content':'435345'}];
        this.learningTips = [{ 'content': '435345' }, { 'content': '435345' }];
        this.developmentTips = '以下方法可以帮助你更好发挥授权能力上的优势，以加速授权成果的展现，同时培养下属的能力：\n' +
            '1.根据任务/责任的性质和授权的风险，判断任务是否需要授权，如果需要授权，判断最有效的授权方式是征求建议、委派任务还是下放职权；\n' +
            '2.依据人员的能力、工作量和个人意愿，结合任务的复杂度和能力要求，综合分析各候选人在各方面的利和弊，对比后选择最佳的授权人选；\n' +
            '3.通过讨论，和被授权者就责任范围、决策范围和绩效期待以及能够提供的资源和支持达成共识；\n' +
            '4.在合适的时机，兑现所承诺提供的资源和支持，鼓励被授权者承担责任的同时，通过不断实践采用提供支持的最佳力度和方式；\n' +
            '5.在项目开始前制定一套追踪流程，项目进行中与被授权者定期沟通以监督进展状况，项目结束后，验收项目是否达到质量标准和时间期限。\n' +
            '发展活动：\n' +
            '被授权的任务完成后进行汇报或分析以检查结果，并就自己的授权表现及被授权者的执行效果征询其他人的反馈意见。';
        switch (this.level) {
            case 6:
                this.chartsData = [
                    { value: 10, name: '薄弱' },
                    { value: 10, name: '有限' },
                    { value: 10, name: '一般' },
                    { value: 10, name: '良好' },
                    { value: 10, name: '优秀' },
                    { value: 10, name: '卓越' },
                    { value: 0, name: '背景' },
                    { value: 20, name: '缺口' },
                ];
                break;
            case 5:
                this.chartsData = [
                    { value: 10, name: '薄弱' },
                    { value: 10, name: '有限' },
                    { value: 10, name: '一般' },
                    { value: 10, name: '良好' },
                    { value: 10, name: '优秀' },
                    { value: 0, name: '卓越' },
                    { value: 10, name: '背景' },
                    { value: 20, name: '缺口' },
                ];
                break;
            case 4:
                this.chartsData = [
                    { value: 10, name: '薄弱' },
                    { value: 10, name: '有限' },
                    { value: 10, name: '一般' },
                    { value: 10, name: '良好' },
                    { value: 0, name: '优秀' },
                    { value: 0, name: '卓越' },
                    { value: 20, name: '背景' },
                    { value: 20, name: '缺口' },
                ];
                break;
            case 3:
                this.chartsData = [
                    { value: 10, name: '薄弱' },
                    { value: 10, name: '有限' },
                    { value: 10, name: '一般' },
                    { value: 0, name: '良好' },
                    { value: 0, name: '优秀' },
                    { value: 0, name: '卓越' },
                    { value: 30, name: '背景' },
                    { value: 20, name: '缺口' },
                ];
                break;
            case 2:
                this.chartsData = [
                    { value: 10, name: '薄弱' },
                    { value: 10, name: '有限' },
                    { value: 0, name: '一般' },
                    { value: 0, name: '良好' },
                    { value: 0, name: '优秀' },
                    { value: 0, name: '卓越' },
                    { value: 40, name: '背景' },
                    { value: 20, name: '缺口' },
                ];
                break;
            case 1:
                this.chartsData = [
                    { value: 10, name: '薄弱' },
                    { value: 0, name: '有限' },
                    { value: 0, name: '一般' },
                    { value: 0, name: '良好' },
                    { value: 0, name: '优秀' },
                    { value: 0, name: '卓越' },
                    { value: 50, name: '背景' },
                    { value: 20, name: '缺口' },
                ];
                break;
        }
        this.chartsOpt = {
            tooltip: {
                show: false,
            },
            legend: {
                show: false,
            },
            toolbox: {
                show: false,
            },
            calculable: true,
            color: ['#F14F0F', '#F1860D', '#E4B80B', '#E6E812', '#81C80F', '#1BB500', 'rgb(90,102,150)', '#3f4c84'],
            series: [
                {
                    name: '访问来源',
                    type: 'pie',
                    radius: ['91%', '100%'],
                    hoverAnimation: false,
                    startAngle: 225,
                    // radius : ['25rem', '30rem'],
                    itemStyle: {
                        normal: {
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            }
                        },
                        emphasis: {
                            label: {
                                show: false,
                                position: 'center',
                                textStyle: {
                                    fontSize: '30',
                                    fontWeight: 'bold'
                                }
                            }
                        }
                    },
                    data: this.chartsData
                }
            ],
        };
    };
    AbilityReportComponent.prototype.getApiData = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.learningMetaId = params['learningPathId'];
            _this.surveyStatus = params['typeId'];
            if (_this.surveyStatus == 1) {
                _this.pageTitle = "能力诊断报告";
                _this.apiServiceUrl = '/survey/beforeTestRepote/';
            }
            else {
                _this.pageTitle = "能力考核报告";
                _this.apiServiceUrl = '/survey/afterTestReport/';
            }
            _this.apiService.getOrCreateLearningPath(String(_this.learningMetaId)).subscribe(function (result) {
                if (result.lock !== 1) {
                    _this.goCourseFlag = true;
                }
                else {
                    _this.goCourseFlag = false;
                }
            });
            _this.apiService.ajax({
                'type': 'GET',
                'url': '/sr' + _this.apiServiceUrl + _this.learningMetaId,
                'data': {}
            }).subscribe(function (result) {
                if (_this.surveyStatus == 2) {
                    _this.report = result;
                    _this.level = result.level;
                    _this.levelDesc = result.levelDesc;
                    _this.faceUrl = "../../assets/picture/reportnew/L" + _this.level + ".png";
                    _this.beforeLevel = result.afterTestContrasts.b_level;
                    _this.afterLevel = result.afterTestContrasts.a_level;
                    _this.beforeLevelName = result.afterTestContrasts.b_levelName;
                    _this.afterLevelName = result.afterTestContrasts.a_levelName;
                    _this.beforeLevelDesc = result.afterTestContrasts.b_levelDesc;
                    _this.afterLevelDesc = result.afterTestContrasts.a_levelDesc;
                    var beforeAdvantages = result.afterTestContrasts.b_advantages;
                    var afterAdvantages = result.afterTestContrasts.a_advantages;
                    _this.beforeLevelAdvantages = '<b>优势行为</b><br/><br/>';
                    for (var i = 0, len = beforeAdvantages.length; i < len; i += 1) {
                        _this.beforeLevelAdvantages += beforeAdvantages[i] + '<br />';
                    }
                    _this.afterLevelAdvantages = '<b>优势行为</b><br/><br/>';
                    for (var i = 0, len = afterAdvantages.length; i < len; i += 1) {
                        _this.afterLevelAdvantages += afterAdvantages[i] + '<br />';
                    }
                    var beforeShort = result.afterTestContrasts.b_shortBoards;
                    var afterShort = result.afterTestContrasts.a_shortBoards;
                    _this.beforeLevelShort = '<b>短板行为</b><br/><br/>';
                    for (var i = 0, len = beforeShort.length; i < len; i += 1) {
                        _this.beforeLevelShort += beforeShort[i] + '<br />';
                    }
                    _this.afterLevelShort = '<b>短板行为</b><br/><br/>';
                    for (var i = 0, len = afterShort.length; i < len; i += 1) {
                        _this.afterLevelShort += afterShort[i] + '<br />';
                    }
                    _this.developmentTips = result.developmentTips;
                }
                else if (_this.surveyStatus == 1) {
                    _this.report = result;
                    _this.level = result.level;
                    _this.levelDesc = result.levelDesc;
                    _this.faceUrl = "../../assets/picture/reportnew/L" + _this.level + ".png";
                    _this.learningPathId = result.learningPathId;
                    _this.courseId = result.courseId;
                    _this.courseName = result.courseName;
                    _this.surveyTutor = result.surveyTutor;
                    var learningTipsTop = Object.keys(result.learningTips);
                    //发展建议
                    _this.learningTips = [];
                    for (var i = 0, len = learningTipsTop.length; i < len; i += 1) {
                        var obj = {};
                        obj['title'] = learningTipsTop[i];
                        obj['content'] = result.learningTips[learningTipsTop[i]];
                        _this.learningTips.push(obj);
                    }
                    //测试
                    _this.advantages = result.advantages;
                    _this.short = result.shortBoards;
                }
                switch (_this.level) {
                    case 6:
                        _this.chartsData = [
                            { value: 10, name: '薄弱' },
                            { value: 10, name: '有限' },
                            { value: 10, name: '一般' },
                            { value: 10, name: '良好' },
                            { value: 10, name: '优秀' },
                            { value: 10, name: '卓越' },
                            { value: 0, name: '背景' },
                            { value: 20, name: '缺口' },
                        ];
                        break;
                    case 5:
                        _this.chartsData = [
                            { value: 10, name: '薄弱' },
                            { value: 10, name: '有限' },
                            { value: 10, name: '一般' },
                            { value: 10, name: '良好' },
                            { value: 10, name: '优秀' },
                            { value: 0, name: '卓越' },
                            { value: 10, name: '背景' },
                            { value: 20, name: '缺口' },
                        ];
                        break;
                    case 4:
                        _this.chartsData = [
                            { value: 10, name: '薄弱' },
                            { value: 10, name: '有限' },
                            { value: 10, name: '一般' },
                            { value: 10, name: '良好' },
                            { value: 0, name: '优秀' },
                            { value: 0, name: '卓越' },
                            { value: 20, name: '背景' },
                            { value: 20, name: '缺口' },
                        ];
                        break;
                    case 3:
                        _this.chartsData = [
                            { value: 10, name: '薄弱' },
                            { value: 10, name: '有限' },
                            { value: 10, name: '一般' },
                            { value: 0, name: '良好' },
                            { value: 0, name: '优秀' },
                            { value: 0, name: '卓越' },
                            { value: 30, name: '背景' },
                            { value: 20, name: '缺口' },
                        ];
                        break;
                    case 2:
                        _this.chartsData = [
                            { value: 10, name: '薄弱' },
                            { value: 10, name: '有限' },
                            { value: 0, name: '一般' },
                            { value: 0, name: '良好' },
                            { value: 0, name: '优秀' },
                            { value: 0, name: '卓越' },
                            { value: 40, name: '背景' },
                            { value: 20, name: '缺口' },
                        ];
                        break;
                    case 1:
                        _this.chartsData = [
                            { value: 10, name: '薄弱' },
                            { value: 0, name: '有限' },
                            { value: 0, name: '一般' },
                            { value: 0, name: '良好' },
                            { value: 0, name: '优秀' },
                            { value: 0, name: '卓越' },
                            { value: 50, name: '背景' },
                            { value: 20, name: '缺口' },
                        ];
                        break;
                }
                _this.chartsOpt = {
                    tooltip: {
                        show: false,
                    },
                    legend: {
                        show: false,
                    },
                    toolbox: {
                        show: false,
                    },
                    calculable: true,
                    color: ['#F14F0F', '#F1860D', '#E4B80B', '#E6E812', '#81C80F', '#1BB500', 'rgb(90,102,150)', '#3f4c84'],
                    series: [
                        {
                            name: '访问来源',
                            type: 'pie',
                            radius: ['91%', '100%'],
                            hoverAnimation: false,
                            startAngle: 225,
                            // radius : ['25rem', '30rem'],
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: false
                                    },
                                    labelLine: {
                                        show: false
                                    }
                                },
                                emphasis: {
                                    label: {
                                        show: false,
                                        position: 'center',
                                        textStyle: {
                                            fontSize: '30',
                                            fontWeight: 'bold'
                                        }
                                    }
                                }
                            },
                            data: _this.chartsData
                        }
                    ],
                };
            });
        });
    };
    AbilityReportComponent.prototype.getCourse = function () {
        var _this = this;
        $('body').removeClass('heightAuto');
        this.apiService.ajax({
            'type': 'GET',
            'url': '/sr/exposeoutapi/setAbilitySession/' + this.learningMetaId + '/2'
        }).subscribe(function (result) { });
        this.apiService.ajax({
            'type': 'GET',
            'url': '/sr' + this.apiServiceUrl + this.learningMetaId,
            'data': {}
        }).subscribe(function (result) {
            _this.learningPathId = result.learningPathId;
            var link = ['course', _this.learningPathId, _this.courseId];
            _this.router.navigate(link);
        });
    };
    AbilityReportComponent.prototype.finishCourse = function () {
        $('body').removeClass('heightAuto');
        var link = ['learning-map'];
        this.router.navigate(link);
    };
    AbilityReportComponent.prototype.close = function () {
        $('body').removeClass('heightAuto');
        var link = ['learning-path', this.learningMetaId];
        this.router.navigate(link);
    };
    AbilityReportComponent.prototype.showStrong = function () {
        $('.strong').addClass('active');
        $('.weak').removeClass('active');
        $('.strongTxt').show();
        $('.shortTxt').hide();
    };
    AbilityReportComponent.prototype.showWeak = function () {
        $('.strong').removeClass('active');
        $('.weak').addClass('active');
        $('.strongTxt').hide();
        $('.shortTxt').show();
    };
    AbilityReportComponent.prototype.slideBtn = function () {
        var _this = this;
        if (this.isClicked) {
            if (this.isSlide) {
                $('#audioPlay').hide();
                // this.showInfo = false;
                // $('.experienceBtn').removeClass('slideUp');
                this.isSlide = false;
            }
            else {
                // $('.experienceBtn').addClass('slideUp');
                this.isSlide = true;
                setTimeout(function () {
                    _this.isSlide = false;
                }, 3000);
                setTimeout(function () {
                    $('#audioPlay').show();
                }, 200);
            }
        }
        else {
            return false;
        }
    };
    AbilityReportComponent.prototype.changeTab = function (event) {
        var tabObject = $(event.target);
        var reportObj = $('.abilityBody');
        tabObject.addClass('active').siblings().removeClass('active');
        reportObj.animate({
            scrollTop: reportObj.scrollTop() + $("." + tabObject.data('target')).offset().top - 90
        }, 20);
    };
    return AbilityReportComponent;
}());
export { AbilityReportComponent };



// WEBPACK FOOTER //
// ./src/app/ability-report/ability-report.component.ts.pre-build-optimizer.js